<template>
    <div v-padding.top="2">
        <div :class="theme.contractStatus">
            <div v-padding.left="3" v-padding.right="3" v-padding.top="2" v-padding.bottom="2">
                <v-text type="subheadling" white>
                    Идентификация пройдена
                </v-text>
            </div>
        </div>
    </div>
</template>

<script>
import theme from './theme.scss';

export default {
    name: 'contract-status',
    props: {
        status: String,
    },
    data() {
        return {
            theme,
        };
    }
}
</script>


// WEBPACK FOOTER //
// ContractStatus.vue?11472e7e